module.exports = __webpack_public_path__ + "media/images/icon-logo-kakao@3x-9232b6a69c1392910cce419b5b6f5707.png";